import { atom } from 'jotai'

export const isOpenDispatchFixedLockedModalAtom = atom(false)
